export const getMark = (markName: string): PerformanceEntry | null => {
    if (!performance.getEntriesByName) return null;

    const marks = performance.getEntriesByName(markName) || [];
    return marks.length > 0 ? marks[0] : null;
};
